// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"0f04ab44","452":"d5192f68","548":"65513bff","750":"fd612db5","822":"fa564fce","826":"f671eb93"}[chunkId] + ".1787105563750.chunk.js";
};